import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { BLUE_LIGHT, OLD_BLUE } from "src/constants/colors";

export const ForecastTypeSelectorRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 8px;
  height: 34px;
`;
export const ForecastRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-bottom: 40px;
`;

export const TableHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const TableTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 20px;
  font-weight: 500;
`;

export const ApplicationPageLink = styled(Link)`
  display: inline-flex;
  height: 34px;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  padding: 0px 10px 0px 14px;
  gap: 8px;
  border: 0;
  background-color: transparent;
  color: rgba(49, 57, 74, 1);
  font-size: 14px;
  text-decoration: none;

  &:hover,
  &:active {
    color: #1453f5;
    background-color: #e5ebfd;
    svg {
      fill: #1453f5;
    }
  }
`;

export const TotalApplicationCountBadge = styled.div`
  background-color: ${BLUE_LIGHT};
  border-radius: 5px;
  color: ${OLD_BLUE};
  font-size: 9px;
  font-weight: 600;
  padding: 4px;
`;
